import { API_GET_ONE_CLIENT_RFP_COUNT_SUCCESS } from '@/actions/ClientRfpCountActionsTs';
const initialState = {
    rfp_unread_count: 0,
};
/** クライアント：案件件数 */
export const clientRfpCount = (state = initialState, result) => {
    const { payload, type } = result;
    switch (type) {
        case API_GET_ONE_CLIENT_RFP_COUNT_SUCCESS: {
            return Object.assign(Object.assign({}, state), payload);
        }
        default: {
            return state;
        }
    }
};
